// How the Lexicon panel reads its one search box (deterministic; roots are never guessed):
//  - spaced Arabic letters (ك ت ب) -> root lookup;
//  - one Arabic word of up to four letters (كتب, رعى) -> root lookup, then word lookup if Lane has
//    no such root; anything longer or with ة (مكتبة, الكتاب) -> word lookup;
//  - Latin in Lane's own transliteration with no lowercase vowels (ktb, bHv) -> root lookup, then
//    English if there is no such root; anything else (book, he wrote it) -> English search.
// Lane's transliteration writes vowels only as diacritics, never in a root, so a word containing
// a/e/i/o/u can never be a Lane root.
export type LexiconPlan={kind:'root'|'word'|'english';fallback:'word'|'english'|null}

const ARABIC=/[؀-ۿ]/
const MARKS=/[ؐ-ًؚ-ٰٟۖ-ۭـ]/g
const LETTER='[\\u0621-\\u064A]'
const SPACED_ROOT=new RegExp(`^${LETTER}(?:\\s+${LETTER}){1,4}$`)
const LANE_TRANSLITERATION=/^[A-Za-z_$*<>|&}~'^`{]+$/

export function planLexiconQuery(raw:string):LexiconPlan|null{
 const input=raw.trim()
 if(!input)return null
 if(ARABIC.test(input)){
  const bare=input.replace(MARKS,'')
  if(SPACED_ROOT.test(bare))return{kind:'root',fallback:null}
  if(!/\s/.test(bare)&&bare.length<=4&&!bare.includes('ة'))return{kind:'root',fallback:'word'}
  return{kind:'word',fallback:null}
 }
 const compact=input.replace(/\s+/g,'')
 if(!/\s/.test(input)&&LANE_TRANSLITERATION.test(compact)&&!/[aeiou]/.test(compact)&&compact.length<=6)return{kind:'root',fallback:'english'}
 return{kind:'english',fallback:null}
}

// Lane marks verb forms with numbers (1-15) or quadriliteral labels (Q. 1, R. Q. 2).
const ROMAN=['','I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII','XIII','XIV','XV']
export const verbFormLabel=(form:string|null|undefined)=>!form?'':/^\d+$/.test(form)&&ROMAN[Number(form)]?`Form ${ROMAN[Number(form)]}`:`Form ${form}`

// Arabic Almanac (ejtaal.net, GPL v3, A. E. Taal): page scans of Hans Wehr, Lane, al-Mawrid and
// more, opened at a root by its Buckwalter transliteration -- the scheme Lane's dataset already
// uses for root.bword. A plain link out; nothing is fetched from it.
export const ejtaalUrl=(transliteration?:string|null)=>`https://ejtaal.net/aa/${transliteration?`#bwq=${encodeURIComponent(transliteration)}`:''}`
